import { api } from '@/services';
import type {
  BuscaApuracaoDetalhadaPayload,
  BuscaApuracaoDetalhadaResponse,
  FiltrosApuracaoDetalhada,
} from '../types';

/**
 * Tempo de espera próprio da Apuração de IBS e CBS (SPEC-006, decisão 10, paliativo).
 * A consulta pode levar minutos para empresa grande (o backend tem command timeout de
 * 300 s em `ApuracaoDetalhadaRepository.TimeoutSegundos`); sem isto a chamada morre no
 * padrão de 30 s (`src/api/turbopro.ts:117`) e a aba desiste antes do servidor responder.
 * Paliativo até a consulta ser acelerada (a correção de verdade é o índice de cobertura).
 */
export const TIMEOUT_APURACAO_DETALHADA_MS = 300000;

export async function fetchBuscaApuracaoDetalhada(
  filtros?: FiltrosApuracaoDetalhada,
  options?: { timeoutMs?: number }
): Promise<BuscaApuracaoDetalhadaResponse> {
  const cnpjContribuinte = (filtros?.empresaId || '').replace(/\D/g, '');

  const payload: BuscaApuracaoDetalhadaPayload = {
    data_emissao_de: filtros?.dataInicio || '',
    data_emissao_ate: filtros?.dataFim || '',
    CNPJ_Contribuinte: cnpjContribuinte,
  };

  return api.post<BuscaApuracaoDetalhadaResponse, BuscaApuracaoDetalhadaPayload>(
    'Documento/BuscaApuracaoDetalhada',
    payload,
    { timeoutMs: options?.timeoutMs }
  );
}
